import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function incomeExpenseData() {
    return axios.post(APP_SETTINGS.API_PATH.FINANCE_DASHBOARD.incomeExpenseData)
}

/*
? data: {
?    startDate: Date(),
?    endDate: Date(),
?    expenseIds: comma separated string of expenseIds
? }
*/
export function fetchExpenseTypeWise(data) {
    return axios.post(APP_SETTINGS.API_PATH.FINANCE_DASHBOARD.incomeExpenseTypeWise, data);
}

export function fetchProjectBudgetLeads() {
    return axios.get(APP_SETTINGS.API_PATH.FINANCE_DASHBOARD.projectBudgetLead);
}

export function fetchMonthlyExpense(monthIdx, token) {
    return axios.post(APP_SETTINGS.API_PATH.FINANCE_DASHBOARD.monthlyExpense, { "requestId": monthIdx }, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}

export function yearlyIncomeExpense(data, token) {
    return axios.post(APP_SETTINGS.API_PATH.FINANCE_DASHBOARD.yearlyIncomeExpense, data, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}